module.exports = __webpack_public_path__ + "static/media/times.4da2aea4.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/DashboardFiles/icons/times.svg
 ** module id = 880
 ** module chunks = 0
 **/